var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shears-divider",attrs:{"dir":"ltr"}},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"shears-divider__shears",attrs:{"data-src":require("assets/img/partner/main/shears.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }